import { useMultipleContents, usePageContent, useXcoreUtils } from "@robe/client/xcore-ui";
import { News, Product } from "xcore/types";
import ProductAccessories from "./ProductAccessories";
import ProductDownloads from "./ProductDownloads";
import ProductFooter from "./ProductFooter";
import ProductIntro from "./ProductIntro";
import ProductNews from "./ProductNews";
import ProductPictures from "./ProductPictures";
import ProductSpecification from "./ProductSpecification";
import ProductVideo from "./ProductVideo";
import ProductKeyFeatures from "./ProductKeyFeatures";
import ProductColors from "./ProductColors";
import { NewsCardNewsValuesFields } from "design-system/robe";

const ProductDetail = () => {
  const { localize } = useXcoreUtils();
  const product = usePageContent<Product>();
  const [productRelatedNews] = useMultipleContents<[News<NewsCardNewsValuesFields>]>();

  const keyFeatures = localize(product.values?.keyFeatures);
  const images = localize(product.values.images);

  return (
    <>
      <ProductIntro />
      {keyFeatures?.length && <ProductKeyFeatures keyFeatures={keyFeatures} />}
      {images?.length && <ProductPictures />}
      {product.values.videos?.length && <ProductVideo />}
      <ProductDownloads />
      {product.values.wheels?.length && <ProductColors />}
      {product.values.accessories?.length && <ProductAccessories />}
      {product.values.specification && <ProductSpecification />}
      {productRelatedNews && productRelatedNews.length > 0 && <ProductNews news={productRelatedNews} />}
      <ProductFooter />
    </>
  );
};

export default ProductDetail;
